import { FC } from 'react';
import classNames from 'classnames';
import { Slider } from '@/components';
import { getSlicePadding } from '@/utils';

import styles from './specialsslider.module.scss';

interface PromoCarouselSkeletonProps {
  background?: string;
  backgroundImage?: string;
  backgroundStyleFixed?: boolean;
  paddingSection?: 'small' | 'medium' | 'large';
  marginBottom?: boolean;
  titleColor?: string;
  seeAllTextColor?: string;
  activeControlColor?: string;
  disableControlColor?: string;
  minHeight?: number;
  title?: string;
  seeMoreText?: string;
  seeAllHref?: string;
}

const PromoCarouselSkeleton: FC<PromoCarouselSkeletonProps> = ({
  background = '',
  backgroundImage = '',
  backgroundStyleFixed = false,
  paddingSection = 'large',
  marginBottom = false,
  titleColor = '',
  seeAllTextColor = '',
  activeControlColor = '',
  disableControlColor = '',
  minHeight = 0,
  title = '',
  seeMoreText = 'SEE ALL',
}) => {
  const breakpoints = {
    1024: {
      spaceBetween: 16,
    },
  };

  const activeArrowColor = activeControlColor || 'initial';
  const disableArrowColor = disableControlColor || 'initial';
  const controlSlideBorder = seeAllTextColor
    ? '1px solid transparent'
    : 'initial';

  const renderSkeletonCard = (index: number) => (
    <div className={styles.special__placeholder} key={index}>
      <div
        className={classNames(
          styles.special__placeholder_image,
          styles.skeleton__shimmer,
        )}
      />
      <div
        className={classNames(
          styles.special__placeholder_title,
          styles.skeleton__shimmer,
        )}
      />
      <div
        className={classNames(
          styles.special__placeholder_code,
          styles.skeleton__shimmer,
        )}
      />
    </div>
  );

  return (
    <section
      className={classNames(
        styles.promo__carousel,
        styles.promo__carousel__skeleton,
        getSlicePadding(paddingSection),
        {
          spacing_bottom: marginBottom,
          ['background__fixed_cover']: backgroundStyleFixed,
          ['background__contained']: !backgroundStyleFixed,
        },
      )}
      style={{
        background,
        backgroundImage: backgroundImage
          ? `url(${backgroundImage})`
          : undefined,
        minHeight: `${minHeight || 0}vh`,
      }}
    >
      <Slider
        activatedHover={false}
        activeAutoplay={false}
        breakpoints={breakpoints}
        centeredSlides={false}
        className={classNames(styles.specials, 'special__carousel')}
        freeMode
        isNotPaddingMobile
        loop={false}
        seeAllElement={
          seeMoreText ? (
            <div
              className={styles.specials__see_all}
              style={{ color: seeAllTextColor }}
            >
              {seeMoreText}
              <span>(0)</span>
            </div>
          ) : undefined
        }
        sliderHeading={
          title ? (
            <h2 className={styles.header} style={{ color: titleColor }}>
              {title}
            </h2>
          ) : undefined
        }
        spaceBetween={12}
      >
        {Array.from({ length: 15 }).map((_, index) =>
          renderSkeletonCard(index),
        )}
      </Slider>
      <style>
        {`.special__carousel {
            .slick-arrow {
              color: ${activeArrowColor};
              border: ${controlSlideBorder};

              &:hover {
                color: ${activeArrowColor}; 
              }

              &.slick-prev {
                border: ${controlSlideBorder};

                &::after {
                  border-right: ${controlSlideBorder};
                }
              }

              &.slick-disabled {
                color: ${disableArrowColor};
              }
            }
          }
        `}
      </style>
    </section>
  );
};

export default PromoCarouselSkeleton;
